import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { getType } from 'typesafe-actions';

import { loginInit, loginValidationSchema } from './login.dtos';
import { loginActions } from './login.actions';
import { Redirect, useHistory } from 'react-router-dom';

import { storageAuthToken } from '../../../common/constants/strings';
import { rootSelector } from '../../../common/selectors/selectors';

import {
  ResponsiveCard,
  ResponsiveCardActions,
  ResponsiveCardContent,
} from '../../../common/components/cards';
import { PasswordTextField } from '../../../common/components/fields';
import { CenterAlign } from '../../../common/components/layout';
import Logo from '../../../common/components/Logo';

import { Button, Grid, Link, TextField } from '@material-ui/core';
import { showNotification } from '../../../common/actionCreators/dispatchNotification';

const Login: React.FC = () => {
  if (sessionStorage.getItem('InvalidToken') === 'true') {
    showNotification('Your password reset request has expired.', 'error');
    sessionStorage.removeItem('InvalidToken');
  }
  const dispatch = useDispatch();
  const history = useHistory();

  let isAuthenticated = sessionStorage.getItem(storageAuthToken) ?? false;
  const auth = rootSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    let isCancelled = false;

    if (!isCancelled) {
      isAuthenticated = auth;
    }

    return () => {
      isCancelled = true;
    };
  }, [isAuthenticated]);

  const onForgotPassword = () => history.push('/forgot-password');

  return (
    <React.Fragment>
      {isAuthenticated ? <Redirect to={'/visitor-information'} /> : null}
      <CenterAlign>
        <ResponsiveCard>
          <Logo />
          <Formik
            initialValues={loginInit}
            validateOnChange={false}
            validationSchema={loginValidationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setTimeout(() => {
                setSubmitting(false);
                resetForm();
              }, 700);
              dispatch({
                type: getType(loginActions.request),
                payload: values,
              });
            }}
            enableReinitialize={true}
          >
            {(props) => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleSubmit,
                handleBlur,
              } = props;
              return (
                <form onSubmit={handleSubmit} noValidate>
                  <ResponsiveCardContent>
                    <Grid container>
                      {/* username */}
                      <Grid item xs={12}>
                        <TextField
                          margin='normal'
                          fullWidth
                          value={values.username}
                          label='Email'
                          name='username'
                          autoComplete='email'
                          autoFocus
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(errors.username)}
                          helperText={
                            errors.username &&
                            touched.username &&
                            errors.username
                          }
                          data-cy='username'
                          required
                        />
                      </Grid>

                      {/* password */}
                      <Grid item xs={12}>
                        <PasswordTextField
                          size='small'
                          margin='normal'
                          name='password'
                          fullWidth
                          value={values.password}
                          label='Password'
                          autoComplete='password'
                          onChange={handleChange}
                          error={Boolean(errors.password)}
                          helperText={
                            errors.password &&
                            touched.password &&
                            errors.password
                          }
                          data-cy='password'
                          required
                        />
                      </Grid>
                    </Grid>
                  </ResponsiveCardContent>

                  <ResponsiveCardActions>
                    <Grid container justify='space-between' alignItems='center'>
                      <Link
                        color='secondary'
                        // disabled={isSubmitting}
                        onClick={onForgotPassword}
                        data-cy='forgotPassword'
                        component='small'
                      >
                        Forgot your password?
                      </Link>

                      <Button
                        color='secondary'
                        variant='text'
                        disabled={isSubmitting}
                        type='submit'
                        data-cy='login'
                      >
                        Login
                      </Button>
                    </Grid>
                  </ResponsiveCardActions>
                </form>
              );
            }}
          </Formik>
        </ResponsiveCard>
      </CenterAlign>
    </React.Fragment>
  );
};

export default Login;
